const is_mobile = device.mobile

let styles = {
    container: {
      padding: '1%',
      display: 'flex',
      justifyContent: 'center',
    },
    table: {
        backgroundColor: '#f5f5f5',
        padding: '0',
        borderRadius:'8px',
        boxShadow:'0 2px 4px rgba(0,0,0,0.1)'
    },
    items: {
        padding: '1%',
        display:'flex',
        alignItems:'center'
    },
    
    item_header: {
        fontWeight: 600,
        paddingLeft: '5%',
        width:'50%'
    },
    
    item_body: {
        padding: '6px',
        width:'40%',
        border:'1px solid #d9d9d9',
        borderRadius:'5px',
        marginLeft:'5%'

    },
    item_ref_court: {
        padding: '0',
        width:'40%',
        border:'1px solid #d9d9d9',
        borderRadius:'5px',
        marginLeft:'5%'
    },
    
    main_header: {
        padding: '1%',
        color: 'white',
        marginBottom: '2%',
        fontSize:'120%',
        textAlign:'center',
        backgroundColor:'#115691',
        borderRadius:'initial'
    },

    input: {
        width: '40%',
        height: 30,
        border:'1px solid #d9d9d9',
        borderRadius:'5px',
        marginLeft:'5%',
        padding:'10px',
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '2% 1% 3% 1%',
        justifyContent: 'center',
        display: 'flex',
    },

    textbox: {
        width: '50%',
        height: 75,
      },

    message: {
        fontSize: '120%',
        fontWeight: 600,
        textAlign: 'center'
    },
    addCourtBtn: {
        background:'#115691',
        color:'white'
    },
    courtTable:{
        border:"1px solid #115691",
    },
    actionTabRow: {
        color:'white',
        background:'#115691',
        textAlign:'center',
    },
    tableData: {
        verticalAlign:'middle',
        textAlign:'center'
    },
    labelSelect: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
    }
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addCourt/style.js